const MultiSelectDropdown = ({ options, selectedOptions, onChange }) => {
  const handleCheckboxChange = (event) => {
    const value = parseInt(event.target.value); // convert to number
    const { checked } = event.target;

    if (checked) {
      onChange([...selectedOptions, value]);
    } else {
      onChange(selectedOptions.filter((item) => item !== value));
    }
  };

  return (
    <div className="custom-multi-select dropdown ">
      <button
        className="btn  form-select dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        style={{
          background: "rgb(255,255,255)", padding: "1px 5px", fontSize: "14px",
          borderStyle: "solid", borderWidth: "1px", borderColor: "rgb(216,216,216)",
          borderImage: "initial", width: "100%", height: "25px", textAlign: "left"
        }}
      >
        Select Depots
      </button>
      <ul className="dropdown-menu" style={{ width: "100%" }}>
        {options.map((option) => (
          <li key={option.value} className="dropdown-item">
            <label>
              <input
                type="checkbox"
                value={option.value}
                checked={selectedOptions.includes(option.value)}
                onChange={handleCheckboxChange} // Trigger change handler
              />
              {` ${option.label}`}
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
};


export default MultiSelectDropdown;
